export const config = {
    sanity : {
        projectId : process.env.REACT_APP_SANITY_PROJECT_ID,
        token : process.env.REACT_APP_SANITY_API_TOKEN,
    },
};
